import {Record, Map, type List, Set} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import type * as Types from './types';
import type * as Models from './models';

export class FiltersAndColumnsState extends Record<{
    isFetching: boolean;
    filtersAndColumnsKind: Types.FiltersAndColumnsKind;
    settingsKind: Types.SettingsKind;
    filterSections: Map<string, Models.FilterSection>;
    columnSections: Map<string, List<Models.Column>>;
    defaultColumns: Set<string>;
    defaultFilters: Map<string, string>;
    institutionId: string;
    shownFilters: Set<string>;
}>({
    isFetching: false,
    filtersAndColumnsKind: 'child' as const,
    settingsKind: 'filters',
    filterSections: Map(),
    columnSections: Map(),
    defaultColumns: Set(),
    defaultFilters: Map(),
    institutionId: '',
    shownFilters: Set(),
}) {}

export default makeReducer<FiltersAndColumnsState>(
    [
        match(Actions.fetchDescription, (state, {payload}) =>
            state.merge({
                isFetching: true,
                institutionId: payload.institutionId,
            }),
        ),
        match(Actions.fetchDescriptionSuccess, (state, {payload}) => {
            return state.merge(
                {
                    isFetching: false,
                },
                payload.filtersAndColumns,
            );
        }),
        match(Actions.fetchDescriptionFailed, state =>
            state.merge({
                isFetching: false,
            }),
        ),
        match(Actions.changeFiltersAndColumnsKind, (state, {payload}) =>
            state.merge({filtersAndColumnsKind: payload.filtersAndColumnsKind}),
        ),
        match(Actions.changeSettingsKind, (state, {payload}) => state.merge({settingsKind: payload.settingsKind})),
        match(Actions.updateShownFilters, (state, {payload}) => state.merge({shownFilters: Set(payload.shownFilters)})),
        match(Actions.hideFilterSection, (state, {payload}) =>
            state.merge({
                shownFilters: state.shownFilters.filter(filterId => !payload.filterEntityIds.includes(filterId)),
            }),
        ),
        match(Actions.reset, () => new FiltersAndColumnsState()),
    ],
    new FiltersAndColumnsState(),
);
